export const checkType = (variable) => {
  if (typeof variable === 'string') {
    return false;
  }
  return true;
};

export const validateExploreCatPayload = (contentType, rnp) => {
  const rnpId = contentType.type !== 1 ? contentType.selectedItem : rnp.ROCKED[0]?.id || null;
  if (rnpId === '') {
    return false;
  }
  return true;
};

export const normalize = (str) => str?.toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ').trim();
